export interface IFormState {
  validar: boolean;
  guardando: boolean;
  error: any;
  response: any;
}

export const InitialFormState: IFormState = {
  validar: false,
  guardando: false,
  error: null,
  response: null,
};
